import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CheckMfaStatusComponent } from './check-mfa-status/check-mfa-status.component';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { AuthStorageService } from '../auth/auth-storage.service';
import { SaveDeviceInfoComponent } from '../verify-identity/save-device-info/save-device-info.component';
import { MockServerService } from 'src/app/shared/mock-server.service';
import { combineLatest, map, Subscription } from 'rxjs';

@Component({
  selector: 'app-verify-login-otp',
  templateUrl: './verify-login-otp.component.html',
  styleUrls: ['./verify-login-otp.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VerifyLoginOTPComponent implements OnInit {
  otpForm: FormGroup;
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  errorMessage = '';
  timer: number = 30; // Resend OTP cooldown (in seconds)
  isResendDisabled: boolean = true;
  staticOtp: string = '123456';
  verified = false;
  email: any;
  mfaToken: string | null = null;
  oobCode: string | null = null;
  isOtpDisabled = false;
  isSmsHidden = false;
  disabledSmsMfaOption: 'true' | 'false' | null | string = null;
  control: any;
  verificationMethod: any;
  trustedDevicePopupTimeoutRef!:any
  showAdminWidget: boolean = false;
  private subscriptions: Subscription[] = [];
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    public authService: AuthenticationService,
    private cookieService: CookieService,
    private router: Router,
    private toastr: ToastrService,
    private authStorage: AuthStorageService,
    public activatedRoute: ActivatedRoute,
    private mockServerService: MockServerService
  ) {
    // const mfaDetails = this.authService.getMfaDetails();
    // this.mfaToken = mfaDetails.mfaToken;
    // this.oobCode = mfaDetails.oobCode;
    // this.email = mfaDetails.email;
    // this.mfaToken = localStorage.getItem('mfa_token');
    // this.oobCode = localStorage.getItem('oob_code');
    // this.email =  localStorage.getItem('email');
    //  this.email = this.cookieService.get('email');
    //  this.mfaToken = this.cookieService.get('mfa_token');
    //  this.oobCode = this.cookieService.get('oob_code')

    // if (!this.mfaToken || !this.oobCode || !this.email) {
    //   this.router.navigate(['/login']);
    // }

    // if (!this.authService.getMfaDetails().mfaToken || !this.authService.getMfaDetails()) {
    //   this.router.navigate(['/login']);
    // }

    // console.log('MFA Token:', this.mfaToken);
    // console.log('OOB Code:', this.oobCode);

    this.otpForm = this.fb.group({
      otp1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp4: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp5: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      otp6: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    });

    this.startTimer(); // Start countdown on component load
  }

  async loadTokens() {
    try {
      this.email = await this.authStorage.getAuthToken('email');
      this.mfaToken = await this.authStorage.getAuthToken('mfa_token');
      this.oobCode = await this.authStorage.getAuthToken('oob_code');

      if (!this.mfaToken || !this.oobCode || !this.email) {
        this.router.navigate(['/login']);
      }
    } catch (err) {
      console.error('Error retrieving tokens:', err);
    }
  }

  async ngOnInit(): Promise<void> {
    //close popup on navigation to error or login page -- trust device popup
    const subscription = this.router.events.subscribe((event) => {
      const restrictedRoutes = ['/error', '/login'];
      if (event instanceof NavigationEnd && restrictedRoutes.some(route => event.url.includes(route))) {
        setTimeout(() => {
          this.dialog.closeAll();
          if (this.trustedDevicePopupTimeoutRef) {
            clearTimeout(this.trustedDevicePopupTimeoutRef);
            this.trustedDevicePopupTimeoutRef = null;
            subscription.unsubscribe();
          }
        });
      }
    });
    this.authService.mfaMethod.subscribe((method) => {
      this.verificationMethod = method;
      console.log(this.verificationMethod, 'verificationMethod');
    });
    this.loadTokens();
    this.authService.getIsSmsHidden$().subscribe((isSmsHidden) => {
      this.isSmsHidden = isSmsHidden;
    });
    this.disabledSmsMfaOption = await this.authService.getdisabledSmsMfaOptionValue()

    // Subscribe to query parameters to check for enable_mock_mode
    // this.activatedRoute.queryParams.subscribe(params => {
    //   const hasMockModeParam = params['enable_mock_mode'] === 'true';
    //   const environmentAllowsMock = this.authService.isMockModeAllowed();
    //   this.showAdminWidget = hasMockModeParam && environmentAllowsMock;
    // });
    const mockParam$ = this.activatedRoute.queryParams.pipe(
      map(params => params['enable_mock_mode'] === 'true')
    );

    const mockServer$ = this.mockServerService.showAdminWidget$;

    this.subscriptions.push(combineLatest([mockParam$, mockServer$]).subscribe(
      ([hasMockModeParam, show]) => {
        const environmentAllowsMock = this.authService.isMockModeAllowed();
        this.showAdminWidget = show || (hasMockModeParam && environmentAllowsMock);
      }
    ));
  }

  ngOnDestroy(): void {
  this.subscriptions.forEach(sub => sub.unsubscribe());
}

  get isAnyControlInvalid(): boolean {
    return Object.keys(this.otpForm.controls).some((field) => {
      const control = this.otpForm.get(field);
      // Only consider a control "invalid" if it's invalid and either touched or dirty
      return (
        control &&
        control.hasError('pattern') &&
        (control.dirty || control.touched)
      );
    });
  }

  /**
   * Handles key input for auto-navigation
   */
  onKeyUp(event: KeyboardEvent, index: number) {
    const inputFields = this.otpInputs.toArray();
    const target = event.target as HTMLInputElement;

    if (event.key >= '0' && event.key <= '9') {
      if (index < inputFields.length - 1) {
        inputFields[index + 1].nativeElement.focus(); // Move to the next input
      }
    } else if (event.key === 'Backspace' && target.value === '') {
      if (index > 0) {
        inputFields[index - 1].nativeElement.focus(); // Move to the previous input
      }
    }
  }

  /**
   * Handles OTP pasting
   */
  onPaste(event: ClipboardEvent) {
    event.preventDefault(); // Prevent default paste behavior
    const pastedData = event.clipboardData?.getData('text') || '';
    const otpDigits = pastedData.replace(/\D/g, '').split('').slice(0, 6); // Extract numbers only

    if (otpDigits.length !== 6) {
      this.errorMessage = 'Invalid OTP. Please enter all 6 digits.';
      return;
    }

    // Fill OTP fields with pasted data
    this.otpInputs.toArray().forEach((input, index) => {
      input.nativeElement.value = otpDigits[index] || '';
      this.otpForm.controls[`otp${index + 1}`].setValue(otpDigits[index] || '');
    });

    // Move focus to the last input
    this.otpInputs.last.nativeElement.focus();
    this.errorMessage = ''; // Clear error message on successful paste
  }

  /**
   * Submits the OTP
   */
  async submitOtp() {
    if (this.otpForm.valid) {
      this.verified = true;
      const otpValue = Object.values(this.otpForm.value).join('');
      this.mfaToken = await this.authStorage.getAuthToken('mfa_token');
      this.oobCode = await this.authStorage.getAuthToken('oob_code');

      // console.log('Entered OTP:', otpValue);
      if (!this.mfaToken || !this.oobCode) {
        this.router.navigate(['/login']);
      }

      // const mfaDetails = this.authService.getMfaDetails();
      // this.mfaToken = mfaDetails.mfaToken;
      // this.oobCode = mfaDetails.oobCode;
      // this.email = mfaDetails.email;

      this.authService
        .verifyOtp(this.email!, this.mfaToken!, this.oobCode!, otpValue)
        .subscribe({
          next: async (res: any) => {
            // this.toastr.success('OTP Verified Successfully');
            // console.log(res, 'OTP Verified Successfully');
            //add code for login.
            window.localStorage.setItem('token', JSON.stringify(res));
            // this.authService.afterMFALogin(res)
            // Initialize both batch status and gateway configuration
            this.authService.initializeConfigurations().then(() => {
              this.authService.afterMFALogin({
                email: this.email,
                ...res,
              });
            });

            // this.authService.triggerRememberDevicePopup = true
            const maxdevice = await this.authService.getMaxTrustedDevices();
            // console.log(maxdevice, 'maxdevice')
            this.authService.getUserTrustedDevices(this.email).subscribe({
              next: (res: any) => {
                //console.log(res ,"res")
                if (
                  res.trusted_devices &&
                  res.trusted_devices.length < maxdevice
                ) {
                  this.trustedDevicePopupTimeoutRef = setTimeout(() => {
                    this.dialog.open(SaveDeviceInfoComponent, {
                      width: '400px',
                      height: 'auto',
                      panelClass: 'saveDevice-dialog-container',
                      disableClose: true,
                      data: {
                        email: this.email,
                        ...res,
                      },
                    });
                  }, 7000);
                }
              },
              error: (err: any) => { },
            });
          },
          error: (err: any) => {
            this.verified = false;
            this.otpForm.reset();
            this.dialog.open(CheckMfaStatusComponent, {
              data: err,
              panelClass: 'checkMFAStatusDialogWrapper',
            });
          },
        });

      this.errorMessage = ''; // Clear any previous errors
    } else {
      this.errorMessage = 'Please enter a valid 6-digit OTP.';
    }

    // const enteredOtp = Object.values(this.otpForm.value).join('');
    // if (enteredOtp !== this.staticOtp) {
    //   this.dialog.open(CheckMfaStatusComponent, {
    //     data: { message: "Invalid OTP or OTP Expired" },
    //     panelClass: 'checkMFAStatusDialogWrapper',
    //   });
    // } else {
    //   console.log('OTP Verified Successfully'); // Handle successful verification
    // }
  }

  /**
   * Starts the OTP resend timer
   */
  startTimer() {
    this.isResendDisabled = true;
    this.timer = 30;

    const interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        this.isResendDisabled = false;
        clearInterval(interval);
      }
    }, 1000);
  }

  /**
   * Handles Resend OTP action
   */
  async resendOtp() {
    this.startTimer();
    this.otpForm.reset();
    this.mfaToken = await this.authStorage.getAuthToken('mfa_token');
    this.oobCode = await this.authStorage.getAuthToken('oob_code');
    const body = {
      mfa_token: this.mfaToken,
      method: this.verificationMethod,
    };
    this.authService.resend2FAChallenge(body).subscribe({
      next: (res: any) => {
        this.setSecureCookie('oob_code', res.oob_code);

        console.log(res);
      },
      error: (err: any) => {
        console.log(err);
      },
    });
    console.log('New OTP sent'); // Replace with actual API call
  }

  setSecureCookie(name: string, value: string) {
    const days = 7; // Set the cookie for 7 days
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000); // Set expiry time

    this.cookieService.set(
      name,
      value,
      expires,
      '/',
      window.location.hostname,
      true,
      'Strict'
    );
  }


    //Admin Widget
    isToggleAdminFlagOpen: boolean = false;
    toggleAdminFlag: boolean = false;
    toggleAdminWidget() {
      this.toggleAdminFlag = !this.toggleAdminFlag;
    }


  mockServerActive = this.mockServerService.getMockServerStatus();

}
